<mat-card>
  <mat-card-header class="border-bottom">
    <mat-card-title>
      Adicionar código de contribuinte
    </mat-card-title>
  </mat-card-header>
  <div class="row m-0 pt-2">
    <div class="mt-2 col-md-12">
      <span class="p-float-label">
        <span class="p-float-label">
          <input
            id="inputtext-valor"
            pInputText
            type="text"
            (keydown)="notText($event)"
            class="input-filters"
            [formControl]="form.get('id_csc')"
          />
          <label for="inputtext-cst"
            >Identificador do código de segurança do contribuinte *</label
          >
        </span>
        <small class="p-error" *ngIf="form.get('id_csc').touched && form.get('id_csc').hasError('maxlength')">
          Identificador só aceita 10 números
        </small>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('id_csc').touched && form.get('id_csc').hasError('required')
        "
      >
        Identificador do código de segurnaça é obrigatório
      </small>
    </div>
    <div class="mt-2 col-md-12 mt-2">
      <span class="p-float-label">
        <input
          id="inputtext-csc"
          class="input-filters"
          pInputText
          [formControl]="form.get('csc')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-csc">Código de segurança do contribuinte *</label>
      </span>
      <small
        class="p-error"
        *ngIf="form.get('csc').touched && form.get('csc').hasError('required')"
      >
        Código de segurança é obrigatório
      </small>
      <small
        class="p-error"
        *ngIf="form.get('csc').touched && form.get('csc').hasError('minlength')"
      >
        Código de segurança deve estar entre 16 e 36 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="form.get('csc').touched && form.get('csc').hasError('maxlength')"
      >
        Código de segurança deve estar entre 16 e 36 caracteres
      </small>
    </div>
  </div>
  <mat-card-actions>
    <div
      class="d-flex justify-content-between align-items-center w-100 flex-wrap mt-2 col-md-12"
    >
      <div
        class="d-flex justify-content-between justify-content-md-start align-items-center mt-2"
        style="flex: 1;"
      >
        <button
          type="button"
          class="mr-md-2"
          mat-stroked-button
          id="cancel-btn"
          [matDialogClose]="undefined"
          [disabled]="loading"
        >
          Cancelar
        </button>
        <button
          id="save-btn"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!form.valid || loading"
        >
          Salvar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
